import React, { useCallback } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import _ from "lodash";
import Socket from "socket";
import grayEye from "assets/images/ct/gray-eyes.png";
import greenEye from "assets/images/ct/green-eyes.png";
import redEye from "assets/images/ct/red-eyes.png";
import eyeUnderline from "assets/images/ct/eye-underline.png";
import techImg from "assets/images/ct/tech.png";
import CtHighFivePlayerList from "./CtHighFivePlayerList";
import ActiveDoubleContainer from "./ActiveDoubleContainer";
import Double5 from "./Double5";
import Double6 from "./Double6";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
const DoublesDiceScreen = ({
  screens,
  diceData,
  roomId,
  currentPlayer,
  discard_pile,
  OtherPlayers,
  playersWithCard,
  playersWithCardInfo,
  playerSelected,
  cardSelected,buzzer_sound,default_audio_effect
}) => {
  const doubles_1_button_text = _.get(
    screens,
    "3_dicerollresult.doubles_1.button",
    "LOSE TURN"
  );
  const doubles_1_info = _.get(
    screens,
    "3_dicerollresult.doubles_1.info",
    "The lizard people are watching you... Even more than usual, that is. Better lay low."
  );
  const doubles_1_title = _.get(
    screens,
    "3_dicerollresult.doubles_1.title",
    "LOSE TURN"
  );

  const doubles_2_button_text = _.get(
    screens,
    "3_dicerollresult.doubles_2.button",
    "MOVE FOUR"
  );
  const doubles_2_info = _.get(
    screens,
    "3_dicerollresult.doubles_2.info",
    "Paths branch out before you. Move 4 spaces. If you land on a conspiracy or corner, you'll get two chances to answer."
  );
  const doubles_2_title = _.get(
    screens,
    "3_dicerollresult.doubles_2.title",

    '"TWO" MANY CHOICES'
  );

  const doubles_3_button_text = _.get(
    screens,
    "3_dicerollresult.doubles_3.button",

    "ROLL AGAIN"
  );
  const doubles_3_info = _.get(
    screens,
    "3_dicerollresult.doubles_3.info",
    "There's a spring in your step today. You get a card from the discard pile and roll again."
  );
  const doubles_3_info_empty = _.get(
    screens,
    "3_dicerollresult.doubles_3.info_empty",

    "You would have gotten a card from the discard pile, if it wasn't empty!"
  );
  const doubles_3_title = _.get(
    screens,
    "3_dicerollresult.doubles_3.title",

    "THREE'S THE MAGIC NUMBER"
  );

  const doubles_4_button1_text = _.get(
    screens,
    "3_dicerollresult.doubles_4.button_1",

    "MOVE 8"
  );
  const doubles_4_button2_text = _.get(
    screens,
    "3_dicerollresult.doubles_4.button_2",

    "ROLL AGAIN"
  );
  const doubles_4_info = _.get(
    screens,
    "3_dicerollresult.doubles_4.info",
    "Finally, your precognition kicks in! Choose to move 8 spaces or roll again."
  );
  const doubles_4_title = _.get(
    screens,
    "3_dicerollresult.doubles_4.title",

    "FOUR THOUGHT"
  );

  const doubles_5_button_text = _.get(
    screens,
    "3_dicerollresult.doubles_5.button",
    "ROLL AGAIN"
  );
  const doubles_5_info_empty = _.get(
    screens,
    "3_dicerollresult.doubles_5.info_empty",
    "Nobody had any cards you could take as a 'gift', so your brilliance goes unrewarded for now... but at least you get to roll again."
  );
  const doubles_5_info_steal_1 = _.get(
    screens,
    "3_dicerollresult.doubles_5.info_steal_1",
    "You've earned a little something! Choose a player to steal from."
  );
  const doubles_5_info_steal_2 = _.get(
    screens,
    "3_dicerollresult.doubles_5.info_steal_2",

    "Pick which card to take from this player."
  );
  const doubles_5_info_steal_3 = _.get(
    screens,
    "3_dicerollresult.doubles_5.info_steal_3",
    "A fellow conspiracist graciously 'gave' you a card, and now you get to roll again, too!"
  );
  const doubles_5_title = _.get(
    screens,
    "3_dicerollresult.doubles_5.title",

    "HIGH FIVE!"
  );

  const doubles_6_button_text = _.get(
    screens,
    "3_dicerollresult.doubles_1.button",
    "CROSS FINGERS"
  );
  const doubles_6_button_0 = _.get(
    screens,
    "3_dicerollresult.doubles_1.button_0",

    "MOVE 12"
  );
  const doubles_6_button_6 = _.get(
    screens,
    "3_dicerollresult.doubles_1.button_6",
    "CONFIRM"
  );
  const doubles_6_info_0_1 = _.get(
    screens,
    "3_dicerollresult.doubles_1.info_0_1",
    "Phew! Well. Crisis averted, book closed, library fees paid off."
  );
  const doubles_6_info_0_2 = _.get(
    screens,
    "3_dicerollresult.doubles_1.info_0_2",

    "Now you get to move 12 spaces. Which is much more fun than the other outcome here!"
  );
  const doubles_6_info_1 = _.get(
    screens,
    "3_dicerollresult.doubles_1.info_1",
    "You've really done it now. You thought that was just any old flesh-bound library book?"
  );
  const doubles_6_info_2 = _.get(
    screens,
    "3_dicerollresult.doubles_1.info_2",

    "Roll a die; if it's another 6... well, hope it's not another 6."
  );
  const doubles_1_info_6_1 = _.get(
    screens,
    "3_dicerollresult.doubles_1.info_6_1",
    "So, it's raining fire, the world is ending, and it's kind of your fault. Go figure."
  );
  const doubles_6_info_6_2 = _.get(
    screens,
    "3_dicerollresult.doubles_1.info_6_2",
    "You lose all your cards, and now have to sit and wait while everyone else discards one of theirs."
  );
  const doubles_6_title = _.get(
    screens,
    "3_dicerollresult.doubles_1.title",
    "ARMAGEDDON"
  );


 
  const diceValueDouble = diceData?.dice[0];

  const buttonPressAction = (type) => {
    let data = {};
    switch (type) {
      case "1":
        data = {
          action: "special-action",
          roomId,
          playerId: currentPlayer?.player_id,
          specialAction: "End Turn"
        };
        break;
      case "2":
        data = {
          action: "special-action",
          roomId,
          playerId: currentPlayer?.player_id,
          specialAction: "Move Four"
        };
        break;

      case "3":
        data = {
          action: "roll-dice",
          roomId,
          playerId: currentPlayer?.player_id,
          special: "Regular"
        };
        break;

      case "4":
        data = {
          action: "roll-dice",
          roomId,
          playerId: currentPlayer?.player_id,
          special: "Regular"
        };
        break;

      case "4.2":
        data = {
          action: "special-action",
          roomId,
          playerId: currentPlayer?.player_id,
          specialAction: "Move Eight"
        };
        break;

      case "5":
        data = {
          action: "roll-dice",
          roomId,
          playerId: currentPlayer?.player_id,
          special: "Regular"
        };
        break;

      case "6":
        data = {
          action: "roll-dice",
          roomId,
          playerId: currentPlayer?.player_id,
          special: "Armageddon"
        };
        break;

      case "move12":
        data = {
          action: "special-action",
          roomId,
          playerId: currentPlayer?.player_id,
          specialAction: "Move Twelve"
        };
        break;
      case "special6":
        data = {
          action: "special-action",
          roomId,
          playerId: currentPlayer?.player_id,
          specialAction: "End Turn"
        };
        break;
      default:
        break;
    }
    Socket.sendMessage(data);
  };
  const handleButtonPress = useCallback(
    _.debounce((type) => buttonPressAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [diceValueDouble, roomId]
  );
  return (
    <>
      {(() => {
        switch (diceValueDouble) {
          case 1:
            return (
              <ActiveDoubleContainer
                TopIcon={grayEye}
                boldHeading={doubles_1_title}
                text={doubles_1_info}
                buttonText={doubles_1_button_text}
                buttonPress={() => handleButtonPress("1")}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
              />
            );
          case 2:
            return (
              <ActiveDoubleContainer
                TopIcon={greenEye}
                boldHeading={doubles_2_title}
                text={doubles_2_info}
                buttonText={doubles_2_button_text}
                buttonPress={() => handleButtonPress("2")}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
              />
            );
          case 3:
            return (
              <ActiveDoubleContainer
                TopIcon={greenEye}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
                smallHeading={doubles_3_title}
                text={
                  _.isEmpty(discard_pile)
                    ? doubles_3_info_empty
                    : doubles_3_info
                }
                buttonText={doubles_3_button_text}
                buttonPress={() => handleButtonPress("3")}
                isDiscardPile={!_.isEmpty(discard_pile)}
                discardPileImage={techImg}
              />
            );
          case 4:
            return (
              <ActiveDoubleContainer
                TopIcon={greenEye}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
                boldHeading={doubles_4_title}
                text={doubles_4_info}
                buttonText={doubles_4_button2_text}
                secondButtonText={doubles_4_button1_text}
                buttonPress={() => handleButtonPress("4")}
                secondButtonPress={() => handleButtonPress("4.2")}
                isFour={true}
              />
            );
          case 5:
            return _.isEmpty(playersWithCard) ? (
              <ActiveDoubleContainer
                TopIcon={greenEye}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
                boldHeading={doubles_5_title}
                text={doubles_5_info_empty}
                buttonText={doubles_5_button_text}
                buttonPress={() => handleButtonPress("5")}
              />
            ) : (
              <Double5
                roomId={roomId}
                buzzer_sound={buzzer_sound}
                default_audio_effect={default_audio_effect}
                currentPlayer={currentPlayer}
                TopIcon={greenEye}
                boldHeading={doubles_5_title}
                text={
                  playerSelected === null
                    ? doubles_5_info_steal_1
                    : _.isEmpty(cardSelected)
                    ? doubles_5_info_steal_2
                    : doubles_5_info_steal_3
                }
                playerSelected={playerSelected}
                playersWithCard={playersWithCard}
                playersWithCardInfo={playersWithCardInfo}
                cardSelected={cardSelected}
              />
            );
          case 6:
            return (
              <Double6
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
                diceData={diceData}
                TopIcon={redEye}
                boldHeading={doubles_6_title}
                text1={doubles_6_info_1}
                text2={doubles_6_info_2}
                buttonText={doubles_6_button_text}
                buttonPress={() => handleButtonPress("6")}
                move12Text1={doubles_6_info_0_1}
                move12Text2={doubles_6_info_0_2}
                move12ButtonText={doubles_6_button_0}
                move12buttonPress={() => handleButtonPress("move12")}
                diceSpecial6Text1={
                  "  So, it's @ raining fire  @ , the @ world is ending  @, and it's kind of your fault. Go figure."
                }
                diceSpecial6Text2={doubles_6_info_6_2}
                diceSpecial6ButtonText={doubles_6_button_6}
                special6buttonPress={() => handleButtonPress("special6")}
              />
            );
          default:
            return null;
        }
      })()}
    </>
  );
};

export default DoublesDiceScreen;
